import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={44}
    height={44}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_15961_1288)">
      <circle cx={22} cy={18} r={18} fill="#1C1E20" />
      <circle cx={22} cy={18} r={17.5} stroke="#3A3F4A" />
    </g>
    <path
      d="M19.5 11L26.5 18L19.5 25"
      stroke="#6791FF"
      strokeWidth={3}
      strokeLinecap="square"
    />
    <defs>
      <filter
        id="filter0_d_15961_1288"
        x={0}
        y={0}
        width={44}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.096875 0 0 0 0 0.096875 0 0 0 0 0.096875 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_15961_1288"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_15961_1288"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgComponent;
